module.exports = {"collection":"vocab-basic-numbers","name":"Basic Numbers","hasAudio":true,"items":[{"id":"vocab-一","kanji":["一"],"readings":["いち"],"meanings":["one"]},{"id":"vocab-二","kanji":["二"],"readings":["に"],"meanings":["two"]},{"id":"vocab-三","kanji":["三"],"readings":["さん"],"meanings":["three"]},{"id":"vocab-四","kanji":["四"],"readings":["よん"],"meanings":["four"]},{"id":"vocab-六","kanji":["六"],"readings":["ろく"],"meanings":["six"]},{"id":"vocab-七","kanji":["七"],"readings":["しち"],"meanings":["seven"]},{"id":"vocab-八","kanji":["八"],"readings":["はち"],"meanings":["eight"]}]}


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/vocab-basic-numbers.json
// module id = 97
// module chunks = 0